import { render, staticRenderFns } from "./paginacao.vue?vue&type=template&id=bb8d0538"
import script from "./paginacao.vue?vue&type=script&lang=js"
export * from "./paginacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports